import { useEffect, useState } from "react";

/**
 * Returns the current window width.
 * The returned value will be updated automatically whenever the window is resized.
 * The update can be debounced by passing a debounceMs parameter.
 * @param {number} [debounceMs=100] - Debounce time in ms.
 * @returns {number} - The current window width.
 */
const useWindow = (debounceMs = 100) => {
    const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);

    useEffect(() => {
        let timeoutId: number | null = null;

        const handleResize = () => {
            if (timeoutId !== null) window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => {
                setWindowWidth(window.innerWidth);
                timeoutId = null;
            }, debounceMs);
        };

        window.addEventListener("resize", handleResize, { passive: true });
        return () => {
            if (timeoutId !== null) window.clearTimeout(timeoutId);
            window.removeEventListener("resize", handleResize);
        };
    }, [debounceMs]);

    return windowWidth;
};

export default useWindow;
